module.exports = __webpack_public_path__ + "static/media/part-02.dcd7a41b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-02.jpg
// module id = 938
// module chunks = 0